import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { loadConfig } from './config/app';
import { initLanguage } from './i18n';
import { initTheme } from './theme/store';
import App from './App';
import './styles/global.css';

/*
    Config first, then everything that reads it.

    The deployment's brand colours and default language come out of config.json,
    so rendering before it lands would paint the wrong theme and the wrong
    language for a frame and then snap. One await is cheaper than that flash.
*/
const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

await loadConfig();
initTheme();
initLanguage();

createRoot(root).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
